import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
  CheckPermissionsPipe,
  CheckSomePermissionsPipe,
} from '../../../pipes/check-permissions/check-permisions.pipe';
import { TabColumnPermissions, TabPermissions } from '../../../types/tab-permission.type';

@Component({
  selector: 'acp-manage-tab-dropdown, [acp-manage-tab-dropdown]',
  imports: [CheckPermissionsPipe, CheckSomePermissionsPipe, RouterModule],
  templateUrl: './manage-tab-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageTabDropdownComponent {
  @Input() manageTabPermissions: TabPermissions = {};
  @Input() columnChecks: TabColumnPermissions = {};
}
